import { GetIexQuote } from "$gql/queries/currentPricing/GetIexQuote.gen";
import { useQueryBundle } from "source/hooks";
import React from "react";
import styles from "./QuickQuote.module.scss";
import { formatPercent } from "@tiicker/util/lib/formats";
import Link from "next/link";

export type QuickQuoteProps = {
  tickerSymbol: string;
};

export function QuickQuote(props: QuickQuoteProps): React.ReactElement {
  const quoteInfo = useQueryBundle(GetIexQuote, {
    variables: { ticker: props.tickerSymbol },
  });

  const percentChange =
    quoteInfo.state === "DONE" && quoteInfo.data.iex.quote?.changePercent
      ? quoteInfo.data.iex.quote.changePercent
      : 0.0;

  return (
    <Link href={`/brand/${props.tickerSymbol}`} prefetch={false}>
      <a className={styles.QuickQuote}>
        <div className={styles.QuickQuote__wrapper}>
          <div className={styles.QuickQuote__tickerWrapper}>
            <span className={styles.QuickQuote__Ticker}>
              {props.tickerSymbol}
            </span>
          </div>
          {quoteInfo.state !== "DONE" ? (
            <span className={styles.QuiteQuote__LoadingPrice}>
              <></>
            </span>
          ) : (
            <span
              className={
                styles.stockPriceDetail +
                " " +
                (percentChange >= 0
                  ? styles.stockPriceDetailUp
                  : styles.stockPriceDetailDown)
              }
            >
              {isFinite(percentChange) ? formatPercent(percentChange) : "—%"}
            </span>
          )}
        </div>
      </a>
    </Link>
  );
}
